slideShowPresenter.directive('slideShowPresenter', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'slide_show_presenter/templates/' + helperService.getRedesignPathPrefix() + 'slideShowPresenter.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
